import { useEffect, useState } from "react";

export default function useAuthenticatedObjectUrl(loader, dependencies = []) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let active = true;
    let objectUrl = null;
    setUrl(null);
    setError(null);
    if (!loader) return () => {};
    Promise.resolve()
      .then(loader)
      .then(blob => {
        if (!active) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(value => {
        if (active) setError(value);
      });
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
    // Callers provide the stable identity of the requested resource.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies);

  return { url, error };
}
